import { __assign, __awaiter, __generator } from "tslib";
import { resolveConfig, } from '@office-start/config-resolver-service';
import { FileType } from '@office-start/document-types';
export function executeUploadConfigDataFlow(options) {
    return __awaiter(this, void 0, void 0, function () {
        var uploadConfig, uploadFileTypes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resolveConfig('uploadConfig', options)];
                case 1:
                    uploadConfig = _a.sent();
                    if (!uploadConfig) {
                        throw new Error('Cannot parse UploadConfig');
                    }
                    uploadFileTypes = new Set([
                        FileType.Excel,
                        FileType.Word,
                        FileType.Pdf,
                        FileType.PowerPoint,
                        FileType.Visio,
                        FileType.Stream,
                    ]);
                    if (options.inMockMode) {
                        uploadFileTypes.add(FileType.Photos);
                        uploadFileTypes.add(FileType.Audio);
                    }
                    return [2 /*return*/, __assign(__assign({}, uploadConfig), { uploadFileTypes: uploadFileTypes, editableFileTypes: new Set([
                                FileType.Excel,
                                FileType.Word,
                                FileType.PowerPoint,
                            ]) })];
            }
        });
    });
}
//# sourceMappingURL=executeUploadConfigDataFlow.js.map